import { trackRenterProfileEvent } from '../../analytics';
import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_LOCATION, TRIGGER_OBJECT, TRIGGER_TYPE } from './globals';

// https://dataportal.zillowgroup.net/event-registry/5990
export const INBOX_PAGE_VIEW_EVENT_TYPE_ID = '5990';
export const emitInboxPageViewEvent = () =>
  trackRenterProfileEvent({
    envelope: {
      event_type_id: INBOX_PAGE_VIEW_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: '175',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.View,
      trigger_location_nm: TRIGGER_LOCATION.RachelInbox,
      trigger_source_nm: TRIGGER_LOCATION.RachelInbox, // Location and source match for this event
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ViewContent,
      topic_tag_txt: [TOPIC_TAG_TXT.RachelSatellite],
    },
    renter_profile: null,
  });
